import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import styles from './product.module.scss';
import { getLinkTag } from '../../utils';

function ProductCard(props) {
  const {
    content,
    cta,
    image,
    link,
    strikethroughSubtitle,
    subtitle,
    title,
  } = props;

  const titleStyle = subtitle ? { marginBottom: '4px' } : {};

  const linkInformation = getLinkTag(link);
  const Tag = linkInformation.tag || '';
  const tagProps = linkInformation.tagProps || {};

  return (
    <div className={styles.card}>
      {image && (
        <>
          {link ? (
            <Tag {...tagProps} className={styles.imgLink}>
              <img src={`${image.file.url}?h=290&w=500`} className={styles.image} alt={title} />
            </Tag>
          ) : (
            <img src={`${image.file.url}?h=290&w=500`} className={styles.image} alt={title} />
          )}
        </>
      )}

      <div className={styles.content}>
        {title && (
          <>
            {link ? (
              <Tag {...tagProps} className={styles.link}>
                <h3 className={styles.title} style={titleStyle}>{title}</h3>
              </Tag>
            ) : (
              <h3 className={styles.title} style={titleStyle}>{title}</h3>
            )}
          </>
        )}

        {strikethroughSubtitle && (
          <p className={styles.strikethroughSubtitle}>{strikethroughSubtitle}</p>
        )}

        {subtitle && (
          <p className={styles.subtitle}>{subtitle}</p>
        )}

        {content && (
          <div
            className={styles.text}
            dangerouslySetInnerHTML={{
              __html: content.childMarkdownRemark.html,
            }}
          />
        )}

        {cta && (
          <div className={styles.wrapper}>
            <Button
              {...cta}
              link={cta.url}
              size="large"
              isMobileFull
            >
              {cta.label}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}

export default ProductCard;

ProductCard.propTypes = {
  content: PropTypes.shape({
    childMarkdownRemark: PropTypes.shape({
      html: PropTypes.string,
    }),
  }),
  cta: PropTypes.shape({
    url: PropTypes.string,
    label: PropTypes.string,
  }),
  image: PropTypes.shape({
    file: PropTypes.shape({
      url: PropTypes.string,
    }),
  }),
  link: PropTypes.string,
  strikethroughSubtitle: PropTypes.string,
  subtitle: PropTypes.string,
  title: PropTypes.string,
};

ProductCard.defaultProps = {
  content: {
    childMarkdownRemark: {
      html: '',
    },
  },
  cta: {
    url: '',
    label: '',
  },
  image: {
    file: {
      url: '',
    },
  },
  link: '',
  strikethroughSubtitle: '',
  subtitle: '',
  title: '',
};
